/**
 * Provides the current experiment or -1 if no provider was initialised or an error occurred retrieving an experiment value
 *
 */

var useGoogle = void 0;
export default {

    useGoogleProvider: function useGoogleProvider(useGoogleProviderFlag) {
        useGoogle = useGoogleProviderFlag;
    },

    $get: ['gwDemoGuidewireExperiment', 'gwGoogleExperiment', function (gwDemoGuidewireExperiment, gwGoogleExperiment) {
        var adapterProvider = useGoogle ? gwGoogleExperiment : gwDemoGuidewireExperiment;

        return {
            /**
             * @param {String} experiment
             * @param {Object} [params]
             * @returns {Promise}
             */
            getExperimentValue: function getExperimentValue(experiment, params) {
                return adapterProvider.getExperimentValue(experiment, params);
            }
        };
    }]
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/abexperiment/AbExperimentService.js
// module id = 1059
// module chunks = 0